import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconMenuButton } from 'src/app/shared/model/icon-menu-button';
import { IconMenuButtonEvent } from 'src/app/shared/model/icon-menu-button-event';
import { IconMenuCreator } from 'src/app/shared/util/icon-menu-creator';

@Component({
  selector: 'app-row-icon-menu',
  templateUrl: './row-icon-menu.component.html',
  styleUrls: ['./row-icon-menu.component.scss']
})
export class RowIconMenuComponent<T> implements OnInit {

  iconButtons: IconMenuButton[];
  @Input() row: T;
  @Input() iconMenuCreator: IconMenuCreator<T>;
  @Output() buttonClicked = new EventEmitter<IconMenuButtonEvent<T>>();
  constructor() { }

  ngOnInit(): void {
    this.iconButtons = this.iconMenuCreator.createIconMenu(this.row);
  }

}
